<template>
    <div class="unified-credentials-card" :id="source.credentialsId">
      <closed-card :cardText="source.displayName" :subtitle="source.name" :accounts="source.accounts" :type="source.type"
                   v-if="['valid', 'unvalidated'].includes(source.status)"/>
      <new-credentials-card :source="source" :focus-on-load="focusOnLoad" :saving="saving" :savingInProcess="savingInProcess"
                            @saving-started="startProgress"
                            @saving-completed="stopProgress(true)"
                            @saving-completed-with-error="stopProgress(false)"
                            v-if="['passwordInvalid', 'new'].includes(source.status)"/>
      <progress-loader :stepInterval="stepInterval" ref="progress" @stopped="progressStopped"></progress-loader>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import NewCredentialsCard from './NewCredentialsCard.vue';
import ProgressLoader from '../../ProgressLoader.vue';
import ClosedCard from '../../ClosedCard.vue';

export default {
  name: 'MultiStateCredentialsCard',
  components: {
    NewCredentialsCard,
    ClosedCard,
    ProgressLoader,
  },
  props: [
    'source',
    'focusOnLoad',
  ],
  data() {
    return {
      saving: false,
      success: false,
    };
  },
  computed: {
    ...mapState('credentials', ['savingInProcess', 'runAfterSave']),
    stepInterval() {
      return this.runAfterSave ? 4000 : 2000;
    },
  },
  methods: {
    ...mapActions('credentials', ['updateCredentialsStatus', 'setSavingInProcess']),
    startProgress() {
      this.saving = true;
      this.setSavingInProcess(true);
      this.$refs.progress.start();
    },
    stopProgress(success) {
      this.success = success;
      this.$refs.progress.stop();
    },
    progressStopped() {
      this.saving = false;
      this.setSavingInProcess(false);
      if (this.success === true) {
        this.updateCredentialsStatus({ source: this.source, status: 'valid' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  .unified-credentials-card {
    position: relative;
  }

</style>
